<template>
    <div>

        <div class="flex-left" style="margin-top: 10px">
            <p><span>{{this.$route.query.code}}模板正在使用企业统计</span></p>
             <a-button style=" position: relative;top: -5px;margin-left:30px;" @click="backBtn">返回</a-button></div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"  style="width: 400px">

        </a-table>

    </div>
</template>

<script>
    import API from "./api";
    const columns = [
        {
            title:"客户名称",
            dataIndex: "company",
            key: "company",
            width: "200px",
        },
        // {
        //     title: "开始使用时间",
        //     dataIndex: "start_time_format",
        //     ellipsis: true,
        //     width: "150px",
        //     key: "start_time_format",
        // },
        // {
        //     title: "结束使用时间",
        //     dataIndex: "end_time_format",
        //     ellipsis: true,
        //     width: "150px",
        //     key: "end_time_format",
        // },
    ];
    export default {
        name: "index",
        data() {
            return {
                id: this.$route.query.id,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/TemplateRecord"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList(1)
        },
        methods: {
            backBtn(){
                this.$router.push({path: '/DataStatistics/TemplateRecord'})
            },
            getList(page) {
                API.server.GET_LIST({page: page || 1,a_template_id:this.id}).then(res => {
                    let data=res.data.data.data
                    data.map((item,index)=>{
                        item.id=index
                    })
                    this.data = data
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.loading = false
                })
            },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .flex-left{display: flex;}
    >>>.ant-table-row-cell-break-word{white-space:nowrap;}
</style>
